import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./context/ThemeContext";
import { ConsultationModalProvider } from "./context/ConsultationModalContext";
import ConsultationModal from "./components/ConsultationModal";
import ChatBot from "./components/ChatBot";
import Home from "./pages/Home";
import Platform from "./pages/Platform";
import Products from "./pages/Products";
import Security from "./pages/Security";
import Solutions from "./pages/Solutions";
import Portals from "./pages/Portals";
import Compliance from "./pages/Compliance";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import SLA from "./pages/SLA";
import PresentationMode from "./pages/PresentationMode";
import ComingSoon from "./pages/ComingSoon";
import Planner from "./pages/Planner";
import LaunchEvent from "./pages/LaunchEvent";
import DemoRequest from "./pages/DemoRequest";

// Helper component to scroll to top on route change
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <ConsultationModalProvider>
            <div className="App font-sans min-h-screen bg-background text-foreground transition-colors duration-300">
              <BrowserRouter>
                <ScrollToTop />
                <Routes>
                {/* Public Website Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/platform" element={<Platform />} />
                <Route path="/products" element={<Products />} />
                <Route path="/security" element={<Security />} />
                
                {/* Solutions Routes mapped to tabs */}
                <Route path="/solutions" element={<Solutions defaultTab="dr" />} />
                <Route path="/dr-backup" element={<Solutions defaultTab="dr" />} />
                <Route path="/managed-services" element={<Solutions defaultTab="managed" />} />
                <Route path="/migration" element={<Solutions defaultTab="migration" />} />
                
                <Route path="/portals" element={<Portals />} />
                <Route path="/compliance" element={<Compliance />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/planner" element={<Planner />} />
                
                {/* Legal Pages */}
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/sla" element={<SLA />} />
                
                {/* CRM & Service Desk - Removed (Separate Product) */}
                <Route path="/crm/*" element={<ComingSoon title="CRM Portal - Coming Soon" />} />
                <Route path="/support/*" element={<ComingSoon title="Service Desk - Coming Soon" />} />
                
                {/* Presentation Mode - Full Screen, No Layout */}
                <Route path="/present" element={<PresentationMode />} />
                <Route path="/launch" element={<LaunchEvent />} />
                <Route path="/demo" element={<DemoRequest />} />
                
                {/* Fallback */}
                <Route path="*" element={<Home />} />
              </Routes>
              <ConsultationModal />
              <ChatBot />
            </BrowserRouter>
          </div>
      </ConsultationModalProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
